// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"274":"a647047e","300":"185a4052","997":"7407b42c"}[chunkId] + ".chunk.css";
};